import { Elm } from "~/javascript/Page/Agents/SignIn.elm";
import Page from "~/javascript/Page.js";

Page.program(Elm.Page.Agents.SignIn, "agents-sign-in-container");
